import React from 'react';

// 首頁「YouTube 系列影片」：一張外框卡片裡的兩欄清單，每列是播放清單名稱（連到 YouTube 播放清單，
// 沒有播放清單的連第一集）加右側淺灰語言標籤。不放縮圖、集數或說明（使用者要頁面簡單，縮圖卡片太重複）。
const PlayLists = [
    {token: "c", lang: "C", title: "C 語言入門",
        youtube: "https://www.youtube.com/watch?v=yWPGumB64tM&list=PLY_qIufNHc293YnIjVeEwNDuqGo8y2Emx"},
    {token: "leetcode30", lang: "C", title: "C 語言的 LeetCode 四月挑戰",
        youtube: "https://www.youtube.com/watch?v=Hy1hE0HBR3U&list=PLY_qIufNHc29OLToHki4t0Z5KIhUzdYxD"},
    {token: "leetcode_may", lang: "C", title: "C 語言的 LeetCode 五月挑戰",
        youtube: "https://www.youtube.com/watch?v=AeVMQYBtcpI&list=PLY_qIufNHc292EYDwe3B6sGYO_vQ7pOLx"},
    {token: "leetcode_june", lang: "Python・C", title: "Python 與 C 的 LeetCode 六月挑戰",
        youtube: "https://www.youtube.com/watch?v=2t-wNtw53o4&list=PLY_qIufNHc29MIuZuIgK1h_qUp5n7gW3g"},
    {token: "leetcode_july", lang: "Python・C++・C", title: "Python、C++ 與 C 的 LeetCode 七月挑戰",
        youtube: "https://www.youtube.com/watch?v=gC6Mzv0M9L8&list=PLY_qIufNHc28gi_vsvJTfsdztKRDnYjmW"},
    {token: "python_chat", lang: "Python", title: "邊聊邊入門 Python 程式設計",
        youtube: "https://www.youtube.com/watch?v=nBiSWKQkqkg"},
    {token: "leetcode_top150", lang: "C", title: "C 語言的 LeetCode 面試精選 150 題挑戰",
        youtube: "https://www.youtube.com/watch?v=a4rrfXWbhLw&list=PLY_qIufNHc2_8vshCojdyZQo3_prlkcCZ"},
]

export const YoutubePlayLists = () => {
    return (
        <div className="card border-dark mb-3">
            <div className="card-header">
                YouTube 系列影片
            </div>
            <div className="card-body row py-2">
                {PlayLists.map((p) => (
                    <div className="col-lg-6" key={p.token}>
                        <div className="d-flex justify-content-between align-items-center py-2 border-bottom">
                            <a href={p.youtube} target="_blank" rel="noopener noreferrer">{p.title}</a>
                            <span className="badge badge-light text-secondary font-weight-normal ml-2">{p.lang}</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>)
}
